import { Interpolation } from "@emotion/core";
import { Colors } from "../../../../design-tokens/colors";
import { DarkTheme, Device } from "../../../../design-tokens/media-queries";
import { Border } from "../../../../design-tokens/borders";
import { grid } from "../../../../design-tokens/grid";
import { Fonts } from "../../../../design-tokens/fonts";

const root: Interpolation = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: Colors.LightGrey,
  padding: grid(2),
  borderRadius: Border.Radius,
  overflow: "hidden",

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },

  [Device.Mobile]: {
    paddingTop: grid(1),
  },
};

const value: Interpolation = {
  fontSize: "30px",
  fontWeight: Fonts.Weight.Bold,

  [Device.DesktopTablet]: {
    fontSize: "35px",
  },
};

const change: Interpolation = {
  display: "flex",
  alignItems: "center",
  height: 24,
  marginBottom: grid(0.5),

  "> :first-of-type": {
    marginRight: 7,
  },
};

const upArrow = (color: string): Interpolation => ({
  display: "block",
  width: "0",
  height: "0",
  borderStyle: "solid",
  borderWidth: "0 5px 10px 5px",
  borderColor: `transparent transparent ${color} transparent`,
});

const downArrow = (color: string): Interpolation => ({
  display: "block",
  width: "0",
  height: "0",
  borderStyle: "solid",
  borderWidth: "10px 5px 0 5px",
  borderColor: `${color} transparent transparent transparent`,
});

const flat: Interpolation = {
  display: "block",
  width: 10,
  height: 4,
  backgroundColor: Colors.BorderGrey,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBorder,
  },
};

const hoverUnderline: Interpolation = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: 4,
};

const styles = {
  root,
  change,
  value,
  upArrow,
  downArrow,
  flat,
  hoverUnderline,
};

export default styles;
